'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogDetailRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogDetailRemote = exports.CatalogDetailRemote = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/catalog-detail' });
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogDetail.js
// module id = dJZv
// module chunks = 60